// extracted by mini-css-extract-plugin
export var label = "_dd-1";
export var reminder = "_dd-0";